import { StockCheckStatus } from '../../../enums/StockCheckStatus';
import { StockCheck, StockCheckItem, StockCheckItemValue } from '../../../app/services/api/generated';
import { DynamicUomSelect } from '../../../components/shared/DymanicUomSelect';

type IProps = {
  value: StockCheckItemValue,
  item: StockCheckItem,
  stockCheckDetail?: StockCheck,
  selectedZoneId: string,
  allZonesEnabled: boolean,
  handleQuantityChange: (itemId: number | undefined, valueId: number | undefined, newQuantityString: string) => void;
  handleQuantityBlur: (itemId: number | undefined, valueId: number | undefined, newQuantityString: string) => void;
}

const StockCountQuantityInput = ({ value, item, stockCheckDetail, selectedZoneId, allZonesEnabled, handleQuantityChange, handleQuantityBlur }: IProps) => {

  return (
    <DynamicUomSelect primaryUom={item.primaryUom}
      allowPrimaryUomDecimal={item.isAllowPartialUomTransactions}
      onQuantityChange={(e) => handleQuantityChange(item.id, value.id, e.target.value)}
      // onQuantityBlur={(e) => handleQuantityBlur(item.id, value.id, e.target.value)}
      seletedUom={value.uom ?? ''}
      quantity={value?.countQuantity}
      uoms={[{
        code: value.uom,
        description: value.uom,
        toPrimaryConversion: value.conversionToPrimary,
      }]}
      disabled={stockCheckDetail?.status === StockCheckStatus.Pending || (selectedZoneId === '-1' && !allZonesEnabled)}
      hideZeroQuantityOnPrint={true}
      formatDecimalOnLoad={false} />
  );
};

export default StockCountQuantityInput;